/* MF: swap the mega-menu picture to the hovered collection's own image (1 Oct 2026) */
(function () {
  var MAP = window.MF_MENU_IMG || {};
  function panelImg(a) {
    var list = a.closest('.mega-menu__list');
    if (!list || !list.parentElement) return null;
    return list.parentElement.querySelector('.mega-menu__content img');
  }
  function parts(img) {
    var card = img.closest('.mega-menu__content-list-item') || img.parentElement;
    return { title: card.querySelector('.resource-card__title'), hidden: card.querySelector('.resource-card__link .visually-hidden'), link: card.querySelector('.resource-card__link') };
  }
  function show(img, url, a) {
    var p = parts(img);
    if (!img.dataset.mfSrc) {
      img.dataset.mfSrc = img.currentSrc || img.src; img.dataset.mfSrcset = img.getAttribute('srcset') || '';
      if (p.title) img.dataset.mfTitle = p.title.textContent;
      if (p.link) img.dataset.mfHref = p.link.getAttribute('href');
    }
    var name = (a.textContent || '').trim();
    if (p.title) p.title.textContent = name;
    if (p.hidden) p.hidden.textContent = name;
    if (p.link) p.link.setAttribute('href', a.getAttribute('href'));
    if (img.dataset.mfNow === url) return;
    img.dataset.mfNow = url;
    img.removeAttribute('srcset');
    img.src = url;
    img.classList.add('mf-menu-swapped');
  }
  function restore(img) {
    if (!img || !img.dataset.mfSrc || !img.dataset.mfNow) return;
    img.dataset.mfNow = '';
    var p = parts(img);
    if (p.title && img.dataset.mfTitle) p.title.textContent = img.dataset.mfTitle;
    if (p.hidden && img.dataset.mfTitle) p.hidden.textContent = img.dataset.mfTitle;
    if (p.link && img.dataset.mfHref) p.link.setAttribute('href', img.dataset.mfHref);
    img.src = img.dataset.mfSrc;
    if (img.dataset.mfSrcset) img.setAttribute('srcset', img.dataset.mfSrcset);
    img.classList.remove('mf-menu-swapped');
  }
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.mega-menu__list a.mega-menu__link');
    if (a) {
      var img = panelImg(a);
      if (!img) return;
      var url = MAP[a.getAttribute('href')];
      if (url) show(img, url, a); else restore(img);
      return;
    }
    if (!(e.target.closest && e.target.closest('.mega-menu__content'))) {
      document.querySelectorAll('img.mf-menu-swapped').forEach(restore);
    }
  });
})();
